import utils from 'utils';
'use strict';

class SearchHome {
  constructor(elem) {
    this.elem = elem;

    this.searchEngineCloseBtn = this.elem.querySelector('.js-search-engine-close');
    this.searchEngineOpenBtn = this.elem.querySelectorAll('.js-search-engine-open');
    this.searchEngine = this.elem.querySelector('.search-engine');

    this.events();
  }

  events() {
    this.searchEngineCloseBtn.addEventListener('click', e => {
      this.close(this.searchEngine);
    });

    for (let btn of this.searchEngineOpenBtn) {
      btn.addEventListener('click', e => {
        e.preventDefault();
        this.open(this.searchEngine);
      });
    }

    utils.mq.md.addListener(e => {
      if (e.matches) {
        this.close(this.searchEngine);
      }
    });
  }

  close(elem) {
    elem.classList.remove('active');
    document.documentElement.style.overflow = 'auto';
  }

  open(elem) {
    elem.classList.add('active');
    document.documentElement.style.overflow = 'hidden';
  }
}


if (document.querySelector('.search-engine-home')) {
  const searchHome = new SearchHome(document.querySelector('.search-engine-home'));
}
